import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface CancelRequest {
    bl_no: string[];
}

export interface CancelResponse {
    statusCode: number;
    message: string;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutTrackingSelectCancel = (
    successCallback?: (data: CancelResponse) => void,
): UseMutationResult<CancelResponse, AxiosError<ApiErrorResponse>, CancelRequest> => {
    // const queryClient = useQueryClient();
    const accessToken = useMorningAuthStore(state => state.accessToken);

    return useMutation<CancelResponse, AxiosError<ApiErrorResponse>, CancelRequest>({
        mutationFn: async requestData => {
            const { bl_no } = requestData;
            const payload = {
                bl_no,
            };

            const response = await axios.put(enum_api_uri.tracking_select_cancel, payload, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            });
            return response.data.data;
        },

        onSuccess: data => {
            successCallback?.(data);
            // queryClient.invalidateQueries({ queryKey: [""] });
        },
    });
};
